import { useSelector } from "react-redux"
import { DecodeHtml } from "../utils/decodeHtml"
import { retrunAssets } from "../utils/getAssets"


const SwimmingPool = () => {

    const state = useSelector(state => state.campusLifeTab)
    const swimmingPool = state?.data?.properties

    const swimmingPoolFacilityDescription = DecodeHtml({html:swimmingPool?.swimmingPoolFacilityDescription?.markup})

    

    const sports = swimmingPool?.swimmingPoolImages !== null ? swimmingPool?.swimmingPoolImages?.items?.map(item=>item?.content?.properties?.image !== null ? retrunAssets(item?.content?.properties?.image[0]?.url) : "") : []
    return (
        <div className="flex flex-col items-center gap-5 py-8 ">
            <h1 className="w-auto  text-center text-slate-900 text-4xl font-bold  capitalize">Swimming Pool Facility</h1>
            <div className="w-auto flex flex-col items-center gap-5 text-center max-w-5xl">
                <p className="text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{swimmingPoolFacilityDescription}</p>
            </div>
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {
                    sports?.map((sport, index) => (
                        <div key={index} className="flex flex-col items-center gap-5">
                            <img src={sport} alt="" className="w-full h-[25rem] object-cover bg-gray-200 rounded-2xl" />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default SwimmingPool